/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFPrivacySpecificTrackingTechEnum = {
    GoogleAnalytics: 'Google Analytics',
    GoogleAdsAdWords: 'Google Ads (AdWords)',
    Facebook: 'Facebook',
    DataDog: 'DataDog',
    Hotjar: 'Hotjar',
    Pendo: 'Pendo',
    ContentSquare: 'ContentSquare'
} as const;
export type CRSFPrivacySpecificTrackingTechEnum = typeof CRSFPrivacySpecificTrackingTechEnum[keyof typeof CRSFPrivacySpecificTrackingTechEnum];


export function CRSFPrivacySpecificTrackingTechEnumFromJSON(json: any): CRSFPrivacySpecificTrackingTechEnum {
    return CRSFPrivacySpecificTrackingTechEnumFromJSONTyped(json, false);
}

export function CRSFPrivacySpecificTrackingTechEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacySpecificTrackingTechEnum {
    return json as CRSFPrivacySpecificTrackingTechEnum;
}

export function CRSFPrivacySpecificTrackingTechEnumToJSON(value?: CRSFPrivacySpecificTrackingTechEnum | null): any {
    return value as any;
}

